import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  DEFAULT_TIMEOUT,
  handleError,
  HttpRequestMethods,
  IDP_APPS
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  STAYS_LOCATION_SEARCH,
  STAYS_TYPEAHEAD
} from '../../constants/booking-stays/stays.constants';
import {
  SearchResult,
  StaysLocationItem,
  StaysSearchResponse
} from '../../models/interface/booking-stays/stays-interface';

@Injectable({
  providedIn: 'root'
})
export class StaysApiService {
  private http = inject(HttpClient);
  private appConfigService = inject(AppConfigService);
  private _errorHandler = handleError.bind(this);

  private getLocationCode = (item: SearchResult): string =>
    item.hierarchyInfo?.airport?.airportCode || item.gaiaId || '';

  private getLocationName = (item: SearchResult): string =>
    item.regionNames?.fullName || item.regionNames?.shortName || '';

  private mapToLocationItem = (item: SearchResult): StaysLocationItem => ({
    code: this.getLocationCode(item),
    name: this.getLocationName(item),
    gaiaId: item.gaiaId || ''
  });

  searchLocations(query: string): Observable<StaysLocationItem[]> {
    const params = this.buildSearchParams();
    const queryWithParams = `/${query}?${params.toString()}`;

    return new ApiBuilder<void, StaysSearchResponse>(
      this.http,
      this.appConfigService
    )
      .app(IDP_APPS.HEADER)
      .endpointKey(STAYS_TYPEAHEAD)
      .method(HttpRequestMethods.GET)
      .queryParams(queryWithParams)
      .errorHandler(this._errorHandler)
      .timeOut(DEFAULT_TIMEOUT)
      .library(STAYS_LOCATION_SEARCH)
      .create()
      .pipe(
        map(
          (response: StaysSearchResponse) =>
            response.sr?.map(this.mapToLocationItem) || []
        )
      );
  }

  private buildSearchParams(): URLSearchParams {
    const params = this.getDefaultSearchParams();
    return new URLSearchParams(params);
  }

  private getDefaultSearchParams(): Record<string, string> {
    return {
      client: 'Homepage',
      lob: 'HOTELS',
      regiontype: '2047',
      siteid: '509010011'
    };
  }
}
